/**
 * <recipe-article-related> — mobile-only prev/next arrows that scroll the "You Might
 * Also Like" card row by one card width. On desktop the row is a plain static flex
 * wrap (no scrolling, arrows hidden via CSS) so this simply no-ops there.
 */
class RecipeArticleRelated extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.recipe-article-related__cards');
    this.prevBtn = this.querySelector('.recipe-article-related__arrow--prev');
    this.nextBtn = this.querySelector('.recipe-article-related__arrow--next');

    this.prevBtn?.addEventListener('click', () => this.scroll(-1));
    this.nextBtn?.addEventListener('click', () => this.scroll(1));
    this.track?.addEventListener('scroll', () => this.updateDisabledState());
    window.addEventListener('resize', () => this.updateDisabledState());

    this.updateDisabledState();
  }

  scroll(direction) {
    if (!this.track) return;
    const card = this.track.querySelector('.recipe-article-related__card');
    const amount = card ? card.getBoundingClientRect().width + 12 : this.track.clientWidth;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  updateDisabledState() {
    if (!this.track) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    // 1px tolerance: fractional scroll positions from smooth-scroll rounding can otherwise
    // leave the "at the end" state permanently just short of maxScroll.
    if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('recipe-article-related')) {
  customElements.define('recipe-article-related', RecipeArticleRelated);
}
